import { FC } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Modal } from 'baby-design'

type SpoilerAlertModalProps = {
  name: string
  revealSurprises: () => void
}
export const SpoilerAlertModalContents: FC<SpoilerAlertModalProps> = ({
  name,
  revealSurprises,
}) => {
  const modal = useModal()

  const handleRevealSurprises = () => {
    revealSurprises()
    modal.hide()
  }

  const icon = (
    <img
      alt="gift box"
      src="https://images.babylist.com/image/upload/v1736300137/registry-icons/gift-box-open.svg"
    />
  )
  const primaryButton = (
    <Button size="lg" variant="primary" onClick={handleRevealSurprises}>
      Show me the gift
    </Button>
  )
  const secondaryButton = (
    <Button size="lg" variant="secondary" onClick={modal.hide}>
      Keep it a surprise
    </Button>
  )
  return (
    <Modal
      showCloseButton
      handleClose={modal.hide}
      icon={icon}
      isOpen={modal.visible}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title="Spoiler alert!"
    >
      {name} asked to keep this gift a surprise. Are you sure you want to look
      now?
    </Modal>
  )
}

const SpoilerAlertModal = NiceModal.create(SpoilerAlertModalContents)

export default SpoilerAlertModal
export const showSpoilerAlertModal = (props: SpoilerAlertModalProps) =>
  NiceModal.show(SpoilerAlertModal, props)
